import Vue from 'vue';
import shareIt from 'vue-share-it';

Vue.use(shareIt);

if (document.querySelector('article.article')) {
  new Vue().$mount('article.article');
}
